import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import Authentication from '../../session';
import withRouter from '../../lib/withRouter';
import Service from '../../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { getBoardsData, getBranchesLatest } from '../../../store/actions';
import { userAssignedBoards } from '../../../store/selectors/userAssignedBoards';
import BoardToSectionDDNew from '../../BaseDropdownComponents/BoardToSectionDDNew';
import LoadingComponent from '../../loadingComponent';

class AssignSubjectToStudents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedStudents: [],
            categoryAssignInfo: [],
            selectAll: false,
            allRowsSelected: false,
            dropdownsData: null,
            preSelectedIds: [],
            currentPage: 0,
            rowsPerPage: 10
        };
        this.service = new Service();
    }

    componentDidMount() {
        this.props.getBoardsData(true);
        this.props.getBranchesLatest(true);

        // Pre-select items if subject was previously assigned
        const { subject } = this.props;
        if (subject?.assignedTo?.length > 0) {
            this.loadPreviousAssignments();
        }
    }

    componentDidUpdate(prevProps) {
        // If boards data just loaded
        if (!prevProps.boards?.length && this.props.boards?.length > 0) {
            // Initialize dropdowns with provided values
            if (this.props.boardId && this.props.classId) {
                // Data will be loaded when dropdown values are set
            }
        }
    }

    loadPreviousAssignments = () => {
        const { subject } = this.props;
        const academicYear = localStorage.getItem('userAcademicYear');

        // Find assignments for current academic year
        const currentYearAssignments = subject.assignedTo?.find(
            a => a.academicYear === academicYear || a.academicYearId === academicYear
        );

        if (currentYearAssignments) {
            const preSelectedIds = [];

            // Collect section IDs and student IDs
            if (currentYearAssignments.sections) {
                currentYearAssignments.sections.forEach(section => {
                    // If section has no studentIds or empty array, entire section is assigned
                    if (!section.studentIds || section.studentIds.length === 0) {
                        if (section.sectionId) {
                            preSelectedIds.push(section.sectionId);
                        }
                    } else {
                        // Only specific students are assigned, add only student IDs
                        preSelectedIds.push(...section.studentIds);
                    }
                });
            }

            this.setState({ preSelectedIds });
        }
    };

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData,
        }, () => {
            // Load data based on dropdown selection
            if (dropdownsData?.branchId && dropdownsData?.classId) {
                this.getAssignmentInfo(
                    dropdownsData.branchId,
                    dropdownsData.boardId,
                    dropdownsData.classId,
                    dropdownsData.sectionId
                );
            }
        });
    }

    getAssignmentInfo = (branchId, boardId, classId, sectionId) => {
        // Only proceed if we have boardId and classId
        if (!boardId || !classId) return;

        this.setState({ isLoading: true });

        const AcademicYear = localStorage.getItem('userAcademicYear');
        const payload = {
            branchId,
            boardId,
            classId,
            sectionId,
            academicYear: AcademicYear
        };

        this.service.post(`${baseUrlAdmin}/fee-structure/assignInfo`, payload, true)
            .then(data => {
                if (data && data.res && data.res.data) {
                    const assignInfo = data.res.data || [];
                    const { subject } = this.props;
                    const currentYearAssignments = subject.assignedTo?.find(
                        a => a.academicYear === AcademicYear || a.academicYearId === AcademicYear
                    );

                    // Add assignment status to each item
                    const enrichedAssignInfo = assignInfo.map(item => {
                        const enrichedItem = { ...item };

                        // If it's a section (not a student), check if it has assignments
                        if (item.sectionId && !item.user_id) {
                            const sectionAssignment = currentYearAssignments?.sections?.find(
                                s => s.sectionId === item.sectionId
                            );

                            if (sectionAssignment) {
                                const studentIds = sectionAssignment.studentIds || [];
                                if (studentIds.length === 0) {
                                    enrichedItem.assignmentStatus = 'All students assigned';
                                    enrichedItem.isAssigned = true; // Mark as assigned for disabling
                                } else {
                                    enrichedItem.assignmentStatus = `${studentIds.length} student${studentIds.length > 1 ? 's' : ''} assigned`;
                                    enrichedItem.isAssigned = true; // Mark as assigned for disabling
                                }
                            }
                        }

                        // If it's a student, check if they're assigned
                        if (item.user_id) {
                            const studentAssigned = currentYearAssignments?.sections?.some(section => {
                                // Check if student is explicitly in studentIds array
                                if (section.studentIds && section.studentIds.includes(item.user_id)) {
                                    return true;
                                }
                                // Check if entire section is assigned (empty studentIds array)
                                // and this student belongs to that section
                                if ((!section.studentIds || section.studentIds.length === 0) &&
                                    section.sectionId === item.sectionId) {
                                    return true;
                                }
                                return false;
                            });
                            if (studentAssigned) {
                                enrichedItem.isAssigned = true; // Mark as assigned for disabling
                            }
                        }

                        return enrichedItem;
                    });

                    // Pre-select previously assigned items
                    const { preSelectedIds } = this.state;
                    let preSelected = [];

                    if (preSelectedIds.length > 0) {
                        preSelected = enrichedAssignInfo.filter(item => {
                            // Check if section is selected (entire section assigned)
                            if (item.sectionId && !item.user_id && preSelectedIds.includes(item.sectionId)) {
                                return true;
                            }
                            // Check if individual student is selected
                            if (item.user_id && preSelectedIds.includes(item.user_id)) {
                                return true;
                            }
                            // NEW: Check if this is a section row and has assignment status
                            // This means some students in this section are assigned
                            if (item.sectionId && !item.user_id && item.assignmentStatus) {
                                return true;  // Check the section checkbox if it has any assignments
                            }
                            return false;
                        });
                    }

                    // Special case: If we're viewing students in a specific section
                    // and that section has ALL students assigned (studentIds: [])
                    // then select all students in the list
                    if (sectionId && currentYearAssignments?.sections) {
                        const sectionAssignment = currentYearAssignments.sections.find(
                            s => s.sectionId === sectionId
                        );

                        // If section is assigned and studentIds is empty, it means ALL students assigned
                        if (sectionAssignment && (!sectionAssignment.studentIds || sectionAssignment.studentIds.length === 0)) {
                            // Select all students in the current view
                            preSelected = enrichedAssignInfo.filter(item => item.user_id);
                        }
                    }

                    this.setState({
                        categoryAssignInfo: enrichedAssignInfo,
                        selectedStudents: preSelected,
                        selectAll: preSelected.length === enrichedAssignInfo.length && enrichedAssignInfo.length > 0,
                        isLoading: false
                    });
                } else {
                    this.setState({
                        categoryAssignInfo: [],
                        isLoading: false
                    });
                    this.props.toast.current?.show({
                        severity: 'info',
                        summary: 'Info',
                        detail: 'No data available',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching assignment info:', error);
                this.setState({ isLoading: false });
                this.props.toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch data',
                    life: 3000
                });
            });
    }

    onAssignStudents = (assignIds, assignType) => {
        const { dropdownsData } = this.state;
        const { subject, boardId, classId, groupId, subjectKey } = this.props;

        if (!dropdownsData?.classId) {
            this.props.toast.current?.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please select board, class and branch',
                life: 3000
            });
            return;
        }

        let academicYear = localStorage.getItem('userAcademicYear');

        // Build payload
        const payload = {
            subjectKey: subjectKey,
            subjectId: subject.subjectId,
            boardId: dropdownsData.boardId || boardId,
            classId: dropdownsData.classId || classId,
            groupId: dropdownsData.groupId || groupId,
            branchId: dropdownsData.branchId,
            sectionId: dropdownsData.sectionId,
            academicYear: academicYear,
            assignType: assignType, // 'sections' or 'users'
            assignIds: assignIds
        };

        this.setState({ isLoading: true });

        this.service.post(`${baseUrlAdmin}/subject/assign-to-students`, payload, true)
            .then(res => {
                const data = res?.data || res;
                if (data && data.status === true && data.res?.success) {
                    this.props.toast.current?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: data.res.message || 'Subject assigned successfully',
                        life: 3000
                    });
                    this.setState({ isLoading: false });
                    setTimeout(() => {
                        this.props.onHide();
                    }, 1000);
                } else {
                    this.setState({ isLoading: false });
                    this.props.toast.current?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: data?.res?.message || 'Failed to assign subject',
                        life: 3000
                    });
                }
            })
            .catch(e => {
                console.error('Error assigning subject:', e);
                this.setState({ isLoading: false });
                this.props.toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to assign subject',
                    life: 3000
                });
            });
    }

    render() {
        const { visible, onHide, subject } = this.props;

        return (
            <Dialog
                visible={visible}
                style={{ width: '96%', height: '96vh' }}
                modal
                blockScroll={true}
                draggable={false}
                closeOnEscape={true}
                dismissableMask={false}
                className='add-a-resource-dialog'
                header={`Assign Subject: ${subject?.subjectName || ''}`}
                onHide={onHide}
            >
                {this.state.isLoading && <LoadingComponent />}
                <div className="p-5">
                    <div className=''>
                        {/* Info message about assignment restrictions */}
                        <div style={{
                            padding: '12px',
                            marginBottom: '16px',
                            backgroundColor: '#e3f2fd',
                            border: '1px solid #2196f3',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <i className="pi pi-info-circle" style={{
                                fontSize: '1.2rem',
                                color: '#2196f3',
                                marginRight: '10px'
                            }}></i>
                            <span style={{ color: '#1565c0', fontSize: '0.95rem' }}>
                                <strong>Note:</strong> Once assigned, sections/students cannot be unassigned.
                                Already assigned items are disabled and shown in gray.
                            </span>
                        </div>

                        <div className="grid mb-2">
                            <BoardToSectionDDNew
                                setValues={this.setDropdownValues}
                                defaultValues={{
                                    boardId: this.props.boardId,
                                    classId: this.props.classId
                                }}
                                disabledFields={{
                                    board: true,
                                    grade: true,
                                    branch: false,
                                    section: false
                                }}
                                branchData={this.props.branchData}
                            />
                        </div>
                    </div>

                    <DataTable
                        value={this.state.categoryAssignInfo}
                        dataKey={this.state?.dropdownsData?.sectionId ? 'user_id' : this.state?.dropdownsData?.classId ? 'sectionId' : 'classId'}
                        paginator
                        rows={this.state.rowsPerPage}
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        responsiveLayout="scroll"
                        sortable
                        first={this.state.currentPage * this.state.rowsPerPage}
                        onPage={(e) => {
                            this.setState({
                                currentPage: e.page,
                                rowsPerPage: e.rows
                            });
                        }}
                        selection={this.state.selectedStudents}
                        onSelectionChange={(e) => {
                            this.setState({
                                selectedStudents: e.value
                            });
                        }}
                        selectAll={this.state.selectAll}
                        onSelectAllChange={(e) => {
                            const { currentPage, rowsPerPage, categoryAssignInfo, selectedStudents } = this.state;

                            // Get items on current page only
                            const startIndex = currentPage * rowsPerPage;
                            const endIndex = startIndex + rowsPerPage;
                            const currentPageItems = categoryAssignInfo.slice(startIndex, endIndex);

                            // Filter to only selectable items (not already assigned)
                            const selectableItemsOnPage = currentPageItems.filter(item => !item.isAssigned);

                            if (e.checked) {
                                // Add current page items to selection (avoiding duplicates)
                                const existingIds = new Set(
                                    selectedStudents.map(s => s.user_id || s.sectionId || s.classId)
                                );
                                const newItems = selectableItemsOnPage.filter(
                                    item => !existingIds.has(item.user_id || item.sectionId || item.classId)
                                );
                                this.setState({
                                    selectedStudents: [...selectedStudents, ...newItems],
                                    selectAll: true
                                });
                            } else {
                                // Remove current page items from selection
                                const pageItemIds = new Set(
                                    selectableItemsOnPage.map(item => item.user_id || item.sectionId || item.classId)
                                );
                                this.setState({
                                    selectedStudents: selectedStudents.filter(
                                        item => !pageItemIds.has(item.user_id || item.sectionId || item.classId)
                                    ),
                                    selectAll: false
                                });
                            }
                        }}
                        selectionMode="checkbox"
                        isDataSelectable={(data) => !data.isAssigned} // Disable selection for assigned items
                        rowClassName={(data) => data.isAssigned ? 'row-disabled' : ''}
                    >
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                        <Column field="branchName" header="Branch Name" className="datatable-cel" sortable />
                        {this.state?.dropdownsData?.branchId && !this.state?.dropdownsData?.sectionId &&
                            <Column
                                field="sectionName"
                                header="Section Name"
                                className="datatable-cel"
                                sortable
                                body={(rowData) => (
                                    <div>
                                        <span>{rowData.sectionName}</span>
                                        {rowData.assignmentStatus && (
                                            <span style={{
                                                marginLeft: '8px',
                                                fontSize: '0.85em',
                                                color: '#666',
                                                fontStyle: 'italic'
                                            }}>
                                                ({rowData.assignmentStatus})
                                            </span>
                                        )}
                                    </div>
                                )}
                            />
                        }
                        {!this.state?.dropdownsData?.sectionId &&
                            <Column field="totalStudents" header="Total Students" className="datatable-cel" sortable />
                        }
                        {this.state?.dropdownsData?.sectionId &&
                            <Column field="username" header="Enrollment ID" className="datatable-cel"
                                body={(rowData) => <p>{(rowData?.username)?.slice(3)}</p>}
                            />
                        }
                        {this.state?.dropdownsData?.sectionId &&
                            <Column field="username" header="Student Name" className="datatable-cel"
                                body={(rowData) => <p>{rowData?.studentName}</p>}
                            />
                        }
                    </DataTable>

                    <div className='flex justify-content-center mb-4 mt-4'>
                        <Button
                            className='submitButtonn w-2'
                            onClick={() => {
                                if (Array.isArray(this.state?.selectedStudents)) {
                                    if (this.state.selectedStudents[0]?.user_id) {
                                        this.onAssignStudents(
                                            this.state.selectedStudents.map(i => i.user_id),
                                            "users"
                                        );
                                    } else if (this.state.selectedStudents[0]?.sectionId) {
                                        this.onAssignStudents(
                                            this.state.selectedStudents.map(i => i.sectionId),
                                            "sections"
                                        );
                                    } else {
                                        this.onAssignStudents(
                                            this.state.selectedStudents.map(i => i.classId),
                                            "grades"
                                        );
                                    }
                                }
                            }}
                        >
                            <p className='submitButtonnText'>Assign</p>
                        </Button>
                        <Button
                            className='cancelButtonn w-2 ml-3'
                            onClick={onHide}
                        >
                            <p className='cancelButtonnText'>Cancel</p>
                        </Button>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                <style>{`
                    .row-disabled {
                        background-color: #f5f5f5 !important;
                        opacity: 0.6;
                        cursor: not-allowed !important;
                    }
                    .row-disabled td {
                        color: #999 !important;
                    }
                `}</style>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoardsWithoutMeluha'),
    isLoading: state.boardsData.loading,
    branchLevels: state.branchDataLatest?.data?.levels,
    branchData: state.branchDataLatest?.data?.data
});

export default connect(
    mapStateToProps,
    { getBoardsData, getBranchesLatest }
)(Authentication(withRouter(AssignSubjectToStudents)));
